import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AppConstants } from '../shared/app.constants';
import { AuthService } from '../auth.service';
var StatisticsService = /** @class */ (function () {
    function StatisticsService(http, appConstants, auth) {
        this.http = http;
        this.appConstants = appConstants;
        this.auth = auth;
    }
    StatisticsService.prototype.fetchStats = function (body) {
        if (body === void 0) { body = {}; }
        var url = environment.apiBase + 'stats';
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.post(url, body, headers).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    StatisticsService.prototype.fetchHours = function (body) {
        var url = environment.apiBase + 'hours/';
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.post(url, body, headers).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    return StatisticsService;
}());
export { StatisticsService };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/statistics/statistics.service.ts.pre-build-optimizer.js